// Tab «Сертификат» of an event (stage J8): what the certificate says, who signs it, the signature and the stamp, a sample PDF and
// «Выпустить сертификаты» — once per person; the letter «сертификат готов» goes from «Сертификаты» by «Письмо выбранным».
import { useState } from 'react';
import { Button, RecordSettings, attachTab, navigate, useToast } from '@confdeck/core-web';
import { command } from './command.ts';
import s from './conferences.module.css';

const Signature = attachTab('cert_signature', 'Подпись — картинка PNG или JPG, лучше на прозрачном фоне.');
const Stamp = attachTab('cert_stamp', 'Печать — картинка PNG или JPG на прозрачном фоне.');

export function EventCertificate({ recordId }: { recordId: string }) {
  const toast = useToast();
  const [busy, setBusy] = useState(false);
  const sample = async () => {
    const r = await command<{ url: string }>('event.certificateSample', { id: recordId });
    if (r.ok) window.open(r.result.url, '_blank'); else toast({ kind: 'error', text: r.message });
  };
  const issue = async () => {
    setBusy(true);
    const r = await command<{ issued: number; already: number; total: number }>('event.issueCertificates', { id: recordId });
    setBusy(false);
    if (!r.ok) { toast({ kind: 'error', text: r.message }); return; }
    toast({ kind: 'info', text: r.result.issued ? `Выпущено сертификатов: ${r.result.issued}, всего ${r.result.total}` : `Новых нет: у всех ${r.result.total} уже есть сертификат` });
  };
  return (
    <section className={s.launch} aria-label="Сертификат">
      <p className={s.tplHint}>Сертификат участия: крупный заголовок, ФИО, «принял(а) участие в …» с названием и датами события, внизу — организация, подписант, подпись и печать. Тексты берутся из проекта, пока у события не задано своё.</p>
      <RecordSettings recordId={recordId} groups={['Сертификат']} />
      <h3 className={s.tplHead}>Подпись</h3>
      <Signature recordId={recordId} />
      <h3 className={s.tplHead}>Печать</h3>
      <Stamp recordId={recordId} />
      <div className={s.launchHead}>
        <Button size="sm" onClick={() => void sample()}>Образец PDF</Button>
        <Button size="sm" variant="primary" disabled={busy} onClick={() => void issue()}>Выпустить сертификаты</Button>
        <Button size="sm" variant="ghost" onClick={() => navigate('/t/certificate')}>Все сертификаты</Button>
      </div>
    </section>
  );
}
